<!-- Navigation -->
<nav
  class="fixed top-0 left-0 right-0 z-50 bg-background/95 dark:bg-slate-900/20 backdrop-blur-sm border-b border-border/40">
  <div class="max-w-6xl mx-auto px-6 lg:px-8">
    <div class="flex justify-between items-center h-16">
      <!-- Logo -->
      <div class="flex items-center space-x-2">
        <div
          class="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center shadow-lg">
          <svg
            class="w-5 h-5 text-white"
            fill="currentColor"
            viewBox="0 0 24 24">
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </div>
        <span
          class="text-xl font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"
          >B2B CRM</span
        >
      </div>

      <!-- Navigation Links -->
      <div class="hidden md:flex items-center space-x-8">
        <a
          href="/#features"
          class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >Features</a
        >
        <a
          href="/#pricing"
          class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >Pricing</a
        >
        <a
          href="/about"
          class="text-sm text-foreground font-medium"
          >About</a
        >
        <a
          href="/contact"
          class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >Contact</a
        >
      </div>

      <!-- Auth Links & Theme Toggle -->
      <div class="hidden md:flex items-center space-x-4">
        <app-theme-toggle
          (themeChange)="onThemeChange($event)"></app-theme-toggle>
        <a
          href="/auth/sign-in"
          class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >Sign In</a
        >
        <a
          href="/auth/sign-up"
          class="bg-foreground text-background px-4 py-2 rounded-md text-sm font-medium hover:bg-foreground/90 transition-colors"
          >Get Started</a
        >
      </div>

      <!-- Mobile Menu Button -->
      <div class="md:hidden flex items-center space-x-2">
        <app-theme-toggle
          (themeChange)="onThemeChange($event)"></app-theme-toggle>
        <button
          class="p-2 rounded-md text-muted-foreground hover:text-foreground hover:bg-accent transition-colors"
          (click)="toggleMobileMenu()">
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</nav>

<!-- Mobile Menu -->
<div
  class="md:hidden fixed inset-0 z-40 bg-background/95 backdrop-blur-sm transition-opacity duration-300"
  [class.opacity-0]="!isMobileMenuOpen"
  [class.opacity-100]="isMobileMenuOpen"
  [class.pointer-events-none]="!isMobileMenuOpen"
  [class.pointer-events-auto]="isMobileMenuOpen"
  *ngIf="isMobileMenuOpen">
  <div class="flex flex-col h-full pt-16">
    <div class="flex-1 px-6 py-8 space-y-8">
      <!-- Mobile Navigation Links -->
      <div class="space-y-6">
        <a
          href="/#features"
          class="block text-lg text-muted-foreground hover:text-foreground transition-colors"
          (click)="toggleMobileMenu()"
          >Features</a
        >
        <a
          href="/#pricing"
          class="block text-lg text-muted-foreground hover:text-foreground transition-colors"
          (click)="toggleMobileMenu()"
          >Pricing</a
        >
        <a
          href="/about"
          class="block text-lg text-foreground font-medium"
          (click)="toggleMobileMenu()"
          >About</a
        >
        <a
          href="/contact"
          class="block text-lg text-muted-foreground hover:text-foreground transition-colors"
          (click)="toggleMobileMenu()"
          >Contact</a
        >
      </div>

      <!-- Mobile Auth Links -->
      <div class="space-y-4 pt-8 border-t border-border">
        <a
          href="/auth/sign-in"
          class="block text-lg text-muted-foreground hover:text-foreground transition-colors"
          (click)="toggleMobileMenu()"
          >Sign In</a
        >
        <a
          href="/auth/sign-up"
          class="block bg-foreground text-background px-6 py-3 rounded-lg text-lg font-medium hover:bg-foreground/90 transition-colors text-center"
          (click)="toggleMobileMenu()"
          >Get Started</a
        >
      </div>
    </div>
  </div>
</div>

<particles [quantity]="200">
  <!-- Hero Section -->
  <section class="pt-24 pb-12 px-6 lg:px-8 bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50 dark:from-slate-900 dark:via-blue-900/20 dark:to-purple-900/20">
    <div class="max-w-4xl mx-auto text-center">
      <div class="hero-content space-y-8">
        <div class="space-y-4">
          <div
            class="inline-flex items-center px-4 py-2 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200 text-sm font-medium">
            <svg
              class="w-4 h-4 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            About Our Company
          </div>
          <h1
            class="text-5xl md:text-6xl lg:text-7xl font-light text-foreground leading-tight tracking-tight">
            Empowering businesses
            <br />
            <span
              class="font-medium bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800 bg-clip-text text-transparent"
              >since 2020</span
            >
          </h1>
        </div>
        <p
          class="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
          We're passionate about revolutionizing how B2B companies manage their customer relationships. Our journey began with a simple mission: make CRM software that actually works for modern businesses.
        </p>
      </div>
    </div>
  </section>
</particles>

<!-- Our Story Section -->
<section class="py-20 px-6 lg:px-8 bg-background">
  <div class="max-w-7xl mx-auto">
    <div class="grid lg:grid-cols-2 gap-16 items-center mb-32">
      <div>
        <h2
          class="text-4xl md:text-5xl font-light text-foreground mb-6 leading-tight">
          Our
          <br />
          <span class="font-medium">Story</span>
        </h2>
        <div class="space-y-6 text-lg text-muted-foreground leading-relaxed">
          <p>
            Founded in 2025 by a team of experienced sales professionals and software engineers, B2B CRM was born out of frustration with existing CRM solutions that were either too complex or too simplistic.
          </p>
          <p>
            We believed there had to be a better way—a CRM that could grow with businesses, integrate seamlessly with existing tools, and actually help sales teams close more deals instead of getting in their way.
          </p>
          <p>
            Today, we're proud to serve over 10,000 businesses worldwide, from startups to Fortune 500 companies, helping them build stronger customer relationships and drive sustainable growth.
          </p>
        </div>
      </div>

      <div>
        <div
          class="bg-card rounded-2xl shadow-xl border border-border overflow-hidden">
          <div
            class="bg-gradient-to-r from-accent/5 to-primary/5 px-6 py-4 border-b border-border">
            <h3 class="font-medium text-foreground">Company Timeline</h3>
          </div>
          <div class="p-6">
            <div class="space-y-6">
              <div class="flex items-start space-x-4">
                <div
                  class="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <span class="text-sm font-medium text-primary">2025</span>
                </div>
                <div>
                  <h4 class="font-medium text-foreground">Company Founded</h4>
                  <p class="text-sm text-muted-foreground">
                    Started with a vision to revolutionize B2B CRM
                  </p>
                </div>
              </div>
              <div class="flex items-start space-x-4">
                <div
                  class="w-12 h-12 bg-success/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <span class="text-sm font-medium text-success">2025</span>
                </div>
                <div>
                  <h4 class="font-medium text-foreground">Private Beta Release</h4>
                  <p class="text-sm text-muted-foreground">
                    Reached our first major milestone
                  </p>
                </div>
              </div>
              <!-- <div class="flex items-start space-x-4">
                <div
                  class="w-12 h-12 bg-warning/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <span class="text-sm font-medium text-warning">2022</span>
                </div>
                <div>
                  <h4 class="font-medium text-foreground">Series A Funding</h4>
                  <p class="text-sm text-muted-foreground">
                    Raised $10M to accelerate growth
                  </p>
                </div>
              </div> -->
              <!-- <div class="flex items-start space-x-4">
                <div
                  class="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <span class="text-sm font-medium text-purple-600">2024</span>
                </div>
                <div>
                  <h4 class="font-medium text-foreground">10,000+ Customers</h4>
                  <p class="text-sm text-muted-foreground">
                    Serving businesses worldwide
                  </p>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Team Section -->
<section class="py-20 px-6 lg:px-8 bg-gradient-to-br from-blue-50/50 to-purple-50/50 dark:from-blue-950/30 dark:to-purple-950/30">
  <div class="max-w-7xl mx-auto">
    <div class="text-center mb-16">
      <h2
        class="text-4xl md:text-5xl font-light text-foreground mb-6 leading-tight">
        Meet our
        <br />
        <span
          class="font-medium bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"
          >leadership team</span
        >
      </h2>
      <p
        class="text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
        Our diverse team of experts brings decades of experience in sales, technology, and business growth.
      </p>
    </div>

    <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
      <!-- Team Member 1 -->
      <magic-card [isDarkTheme]="isDarkTheme">
        <div class="text-center">
          <div
            class="w-24 h-24 bg-gradient-to-br from-blue-500 to-purple-600 rounded-full flex items-center justify-center text-white font-bold text-2xl mx-auto mb-4">
            YA
          </div>
          <h3 class="text-xl font-semibold text-foreground mb-2">Yogesh Agarwal</h3>
          <p class="text-blue-600 dark:text-blue-400 font-medium mb-4">Managing Director & CEO</p>
          <!-- <p class="text-muted-foreground text-sm leading-relaxed">
            Former VP of Sales at TechCorp with 15+ years of B2B sales experience. Passionate about helping businesses scale efficiently. 
          </p> -->
        </div>
      </magic-card>

      <!-- Team Member 2 -->
      <magic-card [isDarkTheme]="isDarkTheme">
        <div class="text-center">
          <div
            class="w-24 h-24 bg-gradient-to-br from-green-500 to-emerald-600 rounded-full flex items-center justify-center text-white font-bold text-2xl mx-auto mb-4">
            VK
          </div>
          <h3 class="text-xl font-semibold text-foreground mb-2">Vivek Ghai</h3>
          <p class="text-green-600 dark:text-green-400 font-medium mb-4">Managing Director & CEO</p>
          <!-- <p class="text-muted-foreground text-sm leading-relaxed">
            Software architect with expertise in scalable systems. Previously led engineering teams at Google and Stripe.
          </p> -->
        </div>
      </magic-card>

      <!-- Team Member 3 -->
      <magic-card [isDarkTheme]="isDarkTheme">
        <div class="text-center">
          <div
            class="w-24 h-24 bg-gradient-to-br from-purple-500 to-pink-600 rounded-full flex items-center justify-center text-white font-bold text-2xl mx-auto mb-4">
            NN
          </div>
          <h3 class="text-xl font-semibold text-foreground mb-2">Nitin Nimbalkar</h3>
          <p class="text-purple-600 dark:text-purple-400 font-medium mb-4">Asst. Vice President</p>
          <!-- <p class="text-muted-foreground text-sm leading-relaxed">
            Product strategist focused on user experience. Former product manager at Salesforce with deep CRM expertise.
          </p> -->
        </div>
      </magic-card>

      <!-- Team Member 4 -->
      <!-- <magic-card [isDarkTheme]="isDarkTheme">
        <div class="text-center">
          <div
            class="w-24 h-24 bg-gradient-to-br from-orange-500 to-red-600 rounded-full flex items-center justify-center text-white font-bold text-2xl mx-auto mb-4">
            EC
          </div>
          <h3 class="text-xl font-semibold text-foreground mb-2">Emily Chen</h3>
          <p class="text-orange-600 dark:text-orange-400 font-medium mb-4">VP of Marketing</p>
          <p class="text-muted-foreground text-sm leading-relaxed">
            Growth marketing expert with a track record of scaling B2B SaaS companies from startup to IPO.
          </p>
        </div>
      </magic-card> -->

      <!-- Team Member 5 -->
      <!-- <magic-card [isDarkTheme]="isDarkTheme">
        <div class="text-center">
          <div
            class="w-24 h-24 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-full flex items-center justify-center text-white font-bold text-2xl mx-auto mb-4">
            DW
          </div>
          <h3 class="text-xl font-semibold text-foreground mb-2">David Wilson</h3>
          <p class="text-teal-600 dark:text-teal-400 font-medium mb-4">VP of Customer Success</p>
          <p class="text-muted-foreground text-sm leading-relaxed">
            Customer success leader dedicated to ensuring our clients achieve their business goals with our platform.
          </p>
        </div>
      </magic-card> -->

      <!-- Team Member 6 -->
      <!-- <magic-card [isDarkTheme]="isDarkTheme">
        <div class="text-center">
          <div
            class="w-24 h-24 bg-gradient-to-br from-indigo-500 to-blue-600 rounded-full flex items-center justify-center text-white font-bold text-2xl mx-auto mb-4">
            LT
          </div>
          <h3 class="text-xl font-semibold text-foreground mb-2">Lisa Thompson</h3>
          <p class="text-indigo-600 dark:text-indigo-400 font-medium mb-4">Head of Engineering</p>
          <p class="text-muted-foreground text-sm leading-relaxed">
            Engineering leader with expertise in building robust, scalable platforms. Former principal engineer at Amazon.
          </p>
        </div>
      </magic-card> -->
    </div>
  </div>
</section>

<!-- Values Section -->
<section class="py-20 px-6 lg:px-8 bg-background">
  <div class="max-w-7xl mx-auto">
    <div class="text-center mb-16">
      <h2
        class="text-4xl md:text-5xl font-light text-foreground mb-6 leading-tight">
        Our
        <br />
        <span class="font-medium">Values</span>
      </h2>
      <p
        class="text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
        These core principles guide everything we do and shape how we build our product and serve our customers.
      </p>
    </div>

    <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
      <!-- Value 1 -->
      <div class="text-center space-y-4">
        <div
          class="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto">
          <svg
            class="w-8 h-8 text-primary"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>
        <h3 class="text-xl font-semibold text-foreground">Innovation First</h3>
        <p class="text-muted-foreground leading-relaxed">
          We constantly push the boundaries of what's possible in CRM technology, always looking for better ways to serve our customers.
        </p>
      </div>

      <!-- Value 2 -->
      <div class="text-center space-y-4">
        <div
          class="w-16 h-16 bg-success/10 rounded-full flex items-center justify-center mx-auto">
          <svg
            class="w-8 h-8 text-success"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        </div>
        <h3 class="text-xl font-semibold text-foreground">Customer Obsessed</h3>
        <p class="text-muted-foreground leading-relaxed">
          Our customers' success is our success. Every decision we make is guided by how it will impact our users' experience and results.
        </p>
      </div>

      <!-- Value 3 -->
      <div class="text-center space-y-4">
        <div
          class="w-16 h-16 bg-warning/10 rounded-full flex items-center justify-center mx-auto">
          <svg
            class="w-8 h-8 text-warning"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
        </div>
        <h3 class="text-xl font-semibold text-foreground">Trust & Transparency</h3>
        <p class="text-muted-foreground leading-relaxed">
          We build trust through transparency, honest communication, and delivering on our promises consistently.
        </p>
      </div>

      <!-- Value 4 -->
      <div class="text-center space-y-4">
        <div
          class="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mx-auto">
          <svg
            class="w-8 h-8 text-purple-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
          </svg>
        </div>
        <h3 class="text-xl font-semibold text-foreground">Continuous Growth</h3>
        <p class="text-muted-foreground leading-relaxed">
          We embrace learning, adapt quickly to change, and continuously improve both our product and ourselves.
        </p>
      </div>

      <!-- Value 5 -->
      <div class="text-center space-y-4">
        <div
          class="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto">
          <svg
            class="w-8 h-8 text-blue-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M21 12a9 9 0 01-9 9m9-9a9 9 0 00-9-9m9 9H3m9 9v-9m0 9c-1.657 0-3-4.03-3-9s1.343-9 3-9m0 18c1.657 0 3-4.03 3-9s-1.343-9-3-9m-9 9a9 9 0 019-9" />
          </svg>
        </div>
        <h3 class="text-xl font-semibold text-foreground">Global Impact</h3>
        <p class="text-muted-foreground leading-relaxed">
          We're building a platform that empowers businesses worldwide to create meaningful connections and drive positive change.
        </p>
      </div>

      <!-- Value 6 -->
      <div class="text-center space-y-4">
        <div
          class="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
          <svg
            class="w-8 h-8 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
          </svg>
        </div>
        <h3 class="text-xl font-semibold text-foreground">Passion & Purpose</h3>
        <p class="text-muted-foreground leading-relaxed">
          We're passionate about what we do and driven by a shared purpose to make business relationships more meaningful.
        </p>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section
  class="py-20 px-6 lg:px-8 bg-gradient-to-br from-blue-600 to-purple-700 relative overflow-hidden">
  <div class="absolute inset-0 bg-black/20"></div>
  <div
    class="absolute inset-0 bg-gradient-to-br from-blue-600/90 to-purple-700/90"></div>

  <!-- Background Pattern -->
  <div class="absolute inset-0 opacity-10">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none">
      <defs>
        <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
          <path
            d="M 10 0 L 0 0 0 10"
            fill="none"
            stroke="currentColor"
            stroke-width="0.5" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grid)" />
    </svg>
  </div>

  <div class="max-w-4xl mx-auto text-center relative z-10">
    <div class="space-y-8">
      <h2 class="text-4xl md:text-5xl font-light text-white mb-6 leading-tight">
        Ready to join our
        <br />
        <span class="font-medium">growing community?</span>
      </h2>

      <p class="text-lg text-white/90 mb-8 leading-relaxed max-w-2xl mx-auto">
        Experience the difference that a truly customer-focused CRM can make for your business. Join thousands of companies that trust B2B CRM.
      </p>

      <div class="flex flex-col sm:flex-row gap-4 justify-center">
        <a
          href="/auth/sign-up"
          class="inline-flex items-center bg-white text-blue-600 px-8 py-4 rounded-lg text-base font-medium hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl">
          Start Your Free Trial
          <svg
            class="ml-2 w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7" />
          </svg>
        </a>
        <a
          href="/contact"
          class="inline-flex items-center bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-base font-medium border border-white/30 hover:bg-white/30 transition-all">
          Contact Our Team
          <svg
            class="ml-2 w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        </a>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="bg-background border-t border-border py-16 px-6 lg:px-8">
  <div class="max-w-7xl mx-auto">
    <div class="grid md:grid-cols-4 gap-8">
      <div>
        <div class="flex items-center space-x-2 mb-6">
          <div
            class="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center shadow-lg">
            <svg
              class="w-5 h-5 text-white"
              fill="currentColor"
              viewBox="0 0 24 24">
              <path d="M20 6L9 17l-5-5" />
            </svg>
          </div>
          <span
            class="text-xl font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"
            >B2B CRM</span
          >
        </div>
        <p class="text-muted-foreground mb-6">
          The complete B2B CRM solution for modern sales teams.
        </p>
        <div class="flex space-x-4">
          <a
            href="#"
            class="text-muted-foreground hover:text-foreground transition-colors">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
            </svg>
          </a>
          <a
            href="#"
            class="text-muted-foreground hover:text-foreground transition-colors">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z" />
            </svg>
          </a>
          <a
            href="#"
            class="text-muted-foreground hover:text-foreground transition-colors">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
          </a>
        </div>
      </div>

      <div>
        <h3 class="font-semibold text-foreground mb-4">Product</h3>
        <ul class="space-y-3 text-muted-foreground text-sm">
          <li>
            <a href="/#features" class="hover:text-foreground transition-colors"
              >Features</a
            >
          </li>
          <li>
            <a href="/#pricing" class="hover:text-foreground transition-colors"
              >Pricing</a
            >
          </li>
          <li>
            <a href="#" class="hover:text-foreground transition-colors"
              >Integrations</a
            >
          </li>
          <li>
            <a href="#" class="hover:text-foreground transition-colors">API</a>
          </li>
        </ul>
      </div>

      <div>
        <h3 class="font-semibold text-foreground mb-4">Company</h3>
        <ul class="space-y-3 text-muted-foreground text-sm">
          <li>
            <a href="/about" class="hover:text-foreground transition-colors"
              >About</a
            >
          </li>
          <li>
            <a href="#" class="hover:text-foreground transition-colors">Blog</a>
          </li>
          <li>
            <a href="#" class="hover:text-foreground transition-colors"
              >Careers</a
            >
          </li>
          <li>
            <a href="/contact" class="hover:text-foreground transition-colors"
              >Contact</a
            >
          </li>
        </ul>
      </div>

      <div>
        <h3 class="font-semibold text-foreground mb-4">Support</h3>
        <ul class="space-y-3 text-muted-foreground text-sm">
          <li>
            <a href="#" class="hover:text-foreground transition-colors"
              >Help Center</a
            >
          </li>
          <li>
            <a href="#" class="hover:text-foreground transition-colors"
              >Documentation</a
            >
          </li>
          <li>
            <a href="#" class="hover:text-foreground transition-colors"
              >Community</a
            >
          </li>
          <li>
            <a href="#" class="hover:text-foreground transition-colors"
              >Status</a
            >
          </li>
        </ul>
      </div>
    </div>

    <div
      class="border-t border-border mt-12 pt-8 text-center text-muted-foreground">
      <p>&copy; 2024 B2B CRM. All rights reserved.</p>
    </div>
  </div>
</footer>